import React from 'react';
import {Link} from 'react-router-dom';
import {DateTime} from 'components/UI/DateTime';
import {UploadImage} from 'components/UI/Image';

class MainNews extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <div className="main-news">
        <div className='main-news-wrap'>
          <div className='main-news-left-image'>
            <Link to={`/tin-tuc/${this.props.slug}/${this.props.id}`}>
              <UploadImage transform="crop" className='main-news-img' width="605" height="365" type="ARTICLE" image={this.props.image}/>
            </Link>
          </div>
          <div className='main-news-right-detail'>
            <h2 className='main-news-title'><Link className='main-news-title' to={`/tin-tuc/${this.props.slug}/${this.props.id}`}>{this.props.title}</Link></h2>
            <p className='main-news-times'><DateTime dateTime={this.props.updatedAt}/></p>
            <p className='main-news-desc'>{this.props.description}</p>
          </div>
        </div>
      </div>
    );
  }
}

export default MainNews;



// WEBPACK FOOTER //
// ./components/news/MainNews.jsx